import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { ConfirmationDialogComponent } from './confirmation-dialog.component';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
    declarations: [ConfirmationDialogComponent],
    exports     : [
        ConfirmationDialogComponent
    ],
    imports: [
        FuseSharedModule,
        MatToolbarModule,
        MatButtonModule,
        MatDialogModule,
        MatIconModule,
        TranslateModule,
    ]
})
export class ConfirmationDialogModule
{
}
